export const isSuccess = (status) => {
    return status === 'SUCCESS' ? true : false
}